import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Supplier } from '../../../../classes/Supplier';
import { GlobalService } from '../../../services/global.service';
import { LoginService } from '../../../services/login.service';
import { ModelService } from '../../../services/model.service';


@Component({
  selector: 'app-supplier',
  templateUrl: './supplier.component.html',
  styleUrls: ['./supplier.component.scss']
})
export class SupplierComponent implements OnInit {

  id: number;
  contentVisible: boolean = false;
  supplierData: Supplier = new Supplier( );

  availableRoles: string[] = [ 'admin', 'installer' ];
  isAvailable: boolean = true;

  constructor ( 
    private route: ActivatedRoute, 
    private model: ModelService,
    private global: GlobalService,
    private loginService: LoginService ) { 
    this.global.setDocumentTitle( 'Supplier Details' );
    if ( this.availableRoles.indexOf( this.loginService.userInfo.role ) === -1 ) this.isAvailable = false;
    else this.isAvailable = true;
  }

  ngOnInit ( ) {
    this.route.params.subscribe(params => {
       this.id = +params['id'];
       this.model.getSupplierDataByID( this.id, ( supplier ) => {
         this.contentVisible = true;
         this.supplierData = supplier;
       });
    });
  }
}



// WEBPACK FOOTER //
// /root/anvel/angular/app/components/suppliers/supplier/supplier.component.ts